<template>
  <v-select
    v-model="selected"
    :items="items"
    multiple
    prepend-icon="filter_list"
    label="Status"
    @input="$emit('filterChange', selected)"
  ></v-select>
</template>

<script>
export default {
  props: {
    selectedValues: Array
  },
  data() {
    return {
      items: [
        { value: "A", text: "open" },
        { value: "B", text: "partial" },
        { value: "C", text: "complete" },
        { value: "X", text: "cancelled" }
      ],
      selected: this.selectedValues
    };
  }
};
</script>
